/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const reset_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M13.628 21.615a.75.75 0 1 0 .248 1.48l-.248-1.48ZM8 21.71l.633-.401-.127-.201-.22-.091L8 21.71ZM9.25 16a.75.75 0 0 0-1.5 0h1.5Zm-.75 6.5v.75a.75.75 0 0 0 .75-.75H8.5ZM2 21.75a.75.75 0 0 0 0 1.5v-1.5ZM2.25 12A9.75 9.75 0 0 1 12 2.25V.75C5.787.75.75 5.787.75 12h1.5ZM12 2.25A9.75 9.75 0 0 1 21.75 12h1.5C23.25 5.787 18.213.75 12 .75v1.5ZM21.75 12c0 4.83-3.512 8.84-8.122 9.615l.248 1.48c5.32-.894 9.374-5.52 9.374-11.095h-1.5ZM8.286 21.018A9.753 9.753 0 0 1 2.25 12H.75c0 4.697 2.878 8.72 6.964 10.405l.572-1.387ZM7.75 16v6.5h1.5V16h-1.5Zm.75 5.75H2v1.5h6.5v-1.5Zm-1.133.363.5.788 1.266-.802-.5-.79-1.266.804Z"
    />
  </svg>
)
export default reset_medium
